import { useTranslation } from 'react-i18next';
import { Link2, Package } from 'lucide-react';
import { Button } from '~/components/ui';

/**
 * Shown to a trader on a CONFIRMED, not-yet-brokered order: they choose
 * whether to ship it themselves from their own inventory, or source it from
 * other sellers who drop-ship to the customer. The choice isn't persisted —
 * it's derived from whether the order has any sub-orders yet.
 */
export function FulfilmentDecision({
  onShipFromInventory,
  onSourceFromSellers,
}: {
  onShipFromInventory: () => void;
  onSourceFromSellers: () => void;
}) {
  const { t } = useTranslation('order');

  return (
    <div>
      <h3 className="text-base font-semibold text-neut-prim mb-1">
        {t('order.sourcing.decision_title')}
      </h3>
      <p className="text-sm text-gray-600 mb-4">
        {t('order.sourcing.decision_subtitle')}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4">
          <div className="flex items-center gap-2 font-semibold text-sm text-neut-prim mb-1">
            <Package size={16} aria-hidden="true" />
            {t('order.sourcing.ship_option_title')}
          </div>
          <p className="text-xs text-gray-600 mb-4">
            {t('order.sourcing.ship_option_description')}
          </p>
          <button
            type="button"
            onClick={onShipFromInventory}
            className="w-full py-2.5 px-4 bg-white border border-prim text-prim rounded-lg hover:bg-prim-50 transition-colors text-sm font-medium"
          >
            {t('order.sourcing.ship_option_button')}
          </button>
        </div>
        <div className="bg-white rounded-lg border-2 border-prim shadow-sm p-4">
          <div className="flex items-center gap-2 font-semibold text-sm text-neut-prim mb-1">
            <Link2 size={16} aria-hidden="true" />
            {t('order.sourcing.source_option_title')}
          </div>
          <p className="text-xs text-gray-600 mb-4">
            {t('order.sourcing.source_option_description')}
          </p>
          <Button onClick={onSourceFromSellers}>
            {t('order.sourcing.add_sub_order')}
          </Button>
        </div>
      </div>
      <p className="text-xs text-gray-400 mt-3">
        {t('order.sourcing.decision_footnote')}
      </p>
    </div>
  );
}
